import React, { useEffect, useState } from "react";
import { LongDateFormat } from "../../constants/DateFormatters";

function AnnouncementItem(props) {
  const [isExpanded, setIsExpanded] = useState(false);
  let expandAction = () => {
    setIsExpanded(!isExpanded);
  };
  const announcementType =
    props.announcement &&
    (props.announcement.announcementType === 0
      ? "important"
      : props.announcement.announcementType === 1
      ? "warning"
      : "information");
  return (
    <div className="multi-announcements">
      <div className="announcement-item">
        <div className="announcement">
          <div onClick={expandAction} className="item-bar">
            <div
              className={isExpanded ? "colour-area-expanded" : "colour-area"}
            >
              <div className={announcementType}>
                <i className="icon-omni-warning-circle" />
              </div>
            </div>
            <div className="title-and-date">
              <div className="title">
                <span
                  title={props.announcement.title}
                  className={announcementType}
                >
                  {props.announcement.title}
                </span>
              </div>
              <div className="expiry">
                <span className={announcementType}>
                  <b>{props._.Expires}: </b>
                  {LongDateFormat(
                    props.announcement.broadcastEndDate,
                    props._.MomentLang
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
        {isExpanded && (
          <div className="announcement-context">
            <div className="message">{props.announcement.message}</div>
            <div className="published">
              <div className="text">{props._.Published}:</div>
              <div className="date">
                {LongDateFormat(
                  props.announcement.broadcastStartDate,
                  props._.MomentLang
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AnnouncementItem;
